/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/require-default-props */
/* eslint-disable react/no-unused-state */
/* eslint-disable no-useless-constructor */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import EmptyState from '../../../../../../../components/EmptyState';
import AlertMessage from '../../../../../../../components/AlertMessage';

import { getCustomerUsersList } from '../../../../../../../redux/tracking-manager';

import THead from './THead';
import TBody from './TBody';
import Pagination from './Pagination';

import './styles.css';

class TrackingTable extends Component {
  constructor(props) {
    super(props);
  }

  _editRow = (row) => {
    const { onRowEdit } = this.props;
    if (onRowEdit) onRowEdit(row);
  };

  _changePageLimit = (pageLimit) => {
    this.setState({
      currentPage: 1,
      paginationConfig: {
        ...this.state.paginationConfig,
        pageLimit,
      },
    });
  };

  _changePage = (page) => {
    const { dispatch, currentCustomerData } = this.props;

    dispatch(getCustomerUsersList({
      taxNumber: currentCustomerData.cnpjDest,
      page,
    }));
  };

  render() {
    const {
      headers,
      data,
      actions,
      errorMessage,
      onRenderCell,
      onCancel,
      onSave,
      totalItems,
      currentPage,
      pageLimit,
    } = this.props;

    if (errorMessage) {
      return (
        <AlertMessage
          error
          box
          className="TrackingTable__error"
          message={errorMessage}
        />
      );
    }

    if (data[0]) {
      return (
        <div className="TrackingTable">
          <table className="TrackingTable__table">
            <THead headerData={headers} actions={actions} />
            <TBody
              rowData={data}
              actions={actions}
              columnData={headers}
              renderCell={onRenderCell}
            />
          </table>
          <Pagination
            currentPage={currentPage}
            pageLimit={pageLimit}
            totalItems={totalItems}
            onPageLimitChange={this._changePageLimit}
            onChangePage={this._changePage}
            onSave={onSave}
            onCancel={onCancel}
          />
        </div>
      );
    }

    return (
      <EmptyState
        message="Não existem dados para a busca realizada."
      />
    );
  }
}

TrackingTable.propTypes = {
  headers: PropTypes.array,
  data: PropTypes.array,
  errorMessage: PropTypes.string,
  renderBatchEdit: PropTypes.func,
  onRenderCell: PropTypes.func,
};

export default TrackingTable;
